import { createReducer, on } from '@ngrx/store'
import { removeUser, setUser } from './auth.action'

import { AuthState } from './auth.state'

export const initialState: AuthState = {
    user: null
}

export const authReducer = createReducer(
    initialState,
    on(setUser, (state, {user}) => {
        return {...state, user}
    }),
    on(removeUser, (state) => {
        return {...state, user: null}
    })
)
